import { Box } from '@mui/material';
import TheGuarantorsLogo from '@/assets/images/updated-logo.png';
import TheGuarantorsGLogo from '@/assets/images/tg-g-logo.svg';
import TransUnionLogo from '@/assets/images/TU-logo.svg';
import TransUnionMobileLogo from '@/assets/images/tu-mobile-logo.svg';
import { externalLinks } from '@/constants/Constants';
import { useGoToExternal } from '@/utils/linkUtils';
import { useReferralId } from '@/features/Registration/hooks/useReferralId';

interface HeaderLogoProps {
  isMobile: boolean;
}

const HeaderLogo = ({ isMobile }: HeaderLogoProps) => {
  const goToExternal = useGoToExternal();
  const { isTransunionReferral } = useReferralId();

  const handleLogoClick = () => {
    goToExternal(externalLinks.homePage, {
      title: 'Go to Main Page',
      path: '/home',
    });
  };

  if (isTransunionReferral) {
    if (!isMobile) {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
          }}
        >
          <Box
            component="img"
            src={TheGuarantorsLogo}
            alt="theGuarantors"
            sx={{
              height: '24px',
              objectFit: 'contain',
            }}
          />
          <Box
            sx={{
              width: '2px',
              height: '32px',
              backgroundColor: '#000000',
            }}
          />
          <Box
            component="img"
            src={TransUnionLogo}
            alt="TransUnion"
            sx={{
              height: '40px',
              objectFit: 'contain',
              marginBottom: '16px',
            }}
          />
        </Box>
      );
    }

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <Box
          component="img"
          src={TheGuarantorsGLogo}
          alt="theGuarantors"
          sx={{
            height: '24px',
            objectFit: 'contain',
          }}
        />
        <Box
          sx={{
            width: '1px',
            height: '26px',
            backgroundColor: '#000000',
          }}
        />
        <Box
          component="img"
          src={TransUnionMobileLogo}
          alt="TransUnion"
          sx={{
            height: '26px',
            objectFit: 'contain',
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={TheGuarantorsLogo}
      alt="theGuarantors"
      onClick={handleLogoClick}
      sx={{
        height: isMobile ? '20px' : '24px',
        cursor: 'pointer',
      }}
    />
  );
};

export default HeaderLogo;
